var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"alt":"","src":_vm.faceMap[_vm.face]}})
}
var staticRenderFns = []

export { render, staticRenderFns }